import styled from 'styled-components';

export const CardContent = styled.div`
  height: ${({ theme }) => theme.spacing[20]};
`;
